import {
  Box,
  Breakpoint,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import React from "react";
import Button from "./Button";
import CloseBtn from "./CloseBtn";
import Heading from "./Heading";

export interface IDialogBoxButton {
  primary: string;
  secondary?: string;
  isDisabled?: boolean;
  isShowBtns?: boolean;
}

export interface IDialogBox {
  open: boolean;
  title: string;
  caption?: string;
  width?: Breakpoint | false;
  minHeight: string;
  btnClass?: string;
  fullWidth: boolean;
  children: React.ReactNode;
  buttons?: IDialogBoxButton;
  onClose?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleSubmit?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const DialogBox: React.FC<IDialogBox> = ({
  open = false,
  width = "lg",
  fullWidth = false,
  btnClass,
  title,
  caption,
  children,
  minHeight,
  buttons = {
    isShowBtns: false,
    primary: "Submit",
    secondary: "Cancel",
    isDisabled: false,
  },
  onClose,
  handleSubmit,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={width}
      fullWidth={fullWidth}
      sx={{ zIndex: 999 }}
      PaperProps={{
        paper: {
          sx: {
            minHeight: minHeight,
          },
        },
      }}
    >
      <Box className="dialog-header">
        <div className="dialog-heading">
          <Heading type="h6" text={title} isBold={true} />
          {caption && <span className="dialog-caption">{caption}</span>}
        </div>
        <CloseBtn onClose={onClose} />
      </Box>
      <DialogContent>{children}</DialogContent>

      {buttons.isShowBtns && (
        <DialogActions sx={{ padding: "0px 22px 15px 0px", columnGap: "10px" }}>
          {buttons.secondary && (
            <Button
              id="close"
              type="button"
              variant="outlined"
              // className={btnClass}
              fullWidth={false}
              onClick={onClose}
              text={buttons.secondary}
              disabled={buttons.isDisabled}
            />
          )}
          <Button
            id="submit"
            variant="contained"
            // className={btnClass}
            fullWidth={false}
            onClick={handleSubmit}
            text={buttons.primary}
            disabled={buttons.isDisabled}
          />
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DialogBox;
